export default "__VITE_ASSET__CtQChI37__"